export const COMMAND_CENTER_QUERY_KEYS = {
    all: ['command-center'] as const,
    search: (q: string) => ['command-center', 'search', q] as const,
};

export const RECENTS_STORAGE_PREFIX = 'command-center:recents:';
export const MAX_RECENT_ITEMS = 20;
export const SEARCH_MIN_CHARS = 2;
export const SEARCH_DEBOUNCE_MS = 300;
